// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "SuccessStory-module--bx--text-truncate--end--O8QBY";
export var bxTextTruncateFront = "SuccessStory-module--bx--text-truncate--front--FnFwC";
export var cardDescription = "SuccessStory-module--cardDescription--xijjU";
export var cardImage = "SuccessStory-module--cardImage--d4cbd";
export var cardText = "SuccessStory-module--cardText--42-Uu";
export var cardTitle = "SuccessStory-module--cardTitle--ivdqq";
export var successCard = "SuccessStory-module--successCard--hOpNy";
export var successContainers = "SuccessStory-module--successContainers--5OLTq";
export var successLink = "SuccessStory-module--successLink--xNsfi";
export var successStories = "SuccessStory-module--successStories--JOpLg";
export var successStoriesDescription = "SuccessStory-module--successStoriesDescription--3qS8q";
export var successStoriesTitle = "SuccessStory-module--successStoriesTitle--+d0iC";